// Путь процесса — общая логика для любого процесса площадки (без Vue, проверяется тестами). [Claude, 03.11.2026]
// Сводку отдаёт бэкенд (src/process_flow): stages[], urgent[], stuck[], light, open, we_count, them_count.

export const LIGHT_TITLES = { red: 'Критично', yellow: 'Внимание', green: 'В норме', grey: 'Нет данных' }

export function plural(n, one, few, many) {
  const a = Math.abs(n) % 100
  const b = a % 10
  if (a > 10 && a < 20) return many
  if (b === 1) return one
  if (b >= 2 && b <= 4) return few
  return many
}

export function stalledText(days) {
  if (days === null || days === undefined) return ''
  if (days === 0) return 'двигалось сегодня'
  return `стоит ${days} ${plural(days, 'день', 'дня', 'дней')}`
}

export function pickByIds(items, ids) {
  const byId = new Map((items || []).map((i) => [i.id, i]))
  return (ids || []).map((id) => byId.get(id)).filter(Boolean)
}

export function flowHeadline(flow) {
  if (!flow || !flow.open) return 'Открытых нет — всё спокойно'
  const parts = [`${flow.open} в работе`]
  if (flow.urgent_count) parts.push(`${flow.urgent_count} срочно`)
  if (flow.stuck_count) parts.push(`${flow.stuck_count} ${plural(flow.stuck_count, 'зависло', 'зависли', 'зависли')}`)
  return parts.join(' · ')
}

export function stageShare(stage, flow) {
  if (!flow || !flow.open || !stage.count) return 0
  return Math.max(8, Math.round((stage.count / flow.open) * 100))
}

// --- Рассказ процесса (стандарт интерфейса, правило 29б): ситуация → отклонения → главное → действие ----------
export const TILES = [
  { key: 'red', title: 'Нарушения', hint: 'Срок прошёл или горит' },
  { key: 'yellow', title: 'Под риском', hint: 'Скоро срок, зависло или не решено' },
  { key: 'green', title: 'В норме', hint: 'Идёт по плану' },
]

export function storyTiles(flow) {
  const lights = flow?.lights || {}
  const money = flow?.money || {}
  const tiles = TILES.map((t) => ({ ...t, count: lights[t.key] || 0, money: money[t.key] || 0 }))
  if (lights.grey) tiles.push({ key: 'grey', title: 'Нет данных', hint: 'У шага нет срока', count: lights.grey, money: money.grey || 0 })
  return tiles
}

export function situationText(flow, { one = 'дело', few = 'дела', many = 'дел' } = {}) {
  if (!flow) return ''
  if (!flow.open) return `Открытых ${many} нет — всё спокойно.`
  const l = flow.lights || {}
  const parts = [`В работе ${flow.open} ${plural(flow.open, one, few, many)}`]
  const tail = []
  if (l.red) tail.push(`${l.red} с нарушением срока`)
  if (l.yellow) tail.push(`${l.yellow} под риском`)
  if (!l.red && !l.yellow) tail.push('всё идёт по плану')
  return `${parts[0]}: ${tail.join(', ')}.`
}

export function minutesSince(iso, nowMs = Date.now()) {
  if (!iso) return null
  const t = Date.parse(iso)
  if (Number.isNaN(t)) return null
  return Math.max(0, Math.floor((nowMs - t) / 60000))
}

export function freshness(iso, { nowMs = Date.now(), staleMinutes = 10, failed = false } = {}) {
  const ago = minutesSince(iso, nowMs)
  if (ago === null) return { state: failed ? 'error' : 'unknown', text: failed ? 'Данные не получены' : '' }
  const time = new Date(Date.parse(iso)).toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' })
  if (failed) return { state: 'error', text: `Не удалось обновить — показаны данные на ${time}` }
  if (ago >= staleMinutes) return { state: 'stale', text: `Данные устарели: последнее обновление в ${time}` }
  return { state: 'fresh', text: `Обновлено в ${time}` }
}

export const SORTS = [
  { key: 'urgency', title: 'Сначала срочные' },
  { key: 'money', title: 'Сначала крупные суммы' },
  { key: 'fresh', title: 'Сначала новые' },
]
const LIGHT_ORDER = { red: 0, yellow: 1, grey: 2, green: 3 }

export function sortItems(items, mode = 'urgency') {
  const list = [...(items || [])]
  if (mode === 'money') return list.sort((a, b) => (b.amount || 0) - (a.amount || 0))
  if (mode === 'fresh') return list.sort((a, b) => String(b.created_at || '').localeCompare(String(a.created_at || '')))
  return list.sort((a, b) => (LIGHT_ORDER[a.light] ?? 3) - (LIGHT_ORDER[b.light] ?? 3)
    || (a.days_left ?? 1e6) - (b.days_left ?? 1e6)
    || (b.stalled_days || 0) - (a.stalled_days || 0))
}
